import { webpFormat, formatWebpParams } from '_lib/utils'

const directives = [{
  key: 'src',
  options: {
    bind: function (el, binding, vnode) {
      const _bind = () => {
        if (el.tagName == 'IMG') {
          el.src = formatWebpParams(binding.value)
        }
      }
      if (window.SUPPORT_WEBP) {
        _bind()
      } else {
        webpFormat().then(() => {_bind()})
      }
    },
    update: function(el, binding, vnode) {
      if (el.tagName == 'IMG' && binding.value != binding.oldValue) {
        el.src = formatWebpParams(binding.value)
      }
    }
  }
}, {
  key: 'bg',
  options: {
    bind: function (el, binding, vnode) {
      const _bind = () => {
        const regx = /url\((.*?)\)/g
        let value = binding.value
        let temp
        while(temp = regx.exec(binding.value)) {
          value = value.replace(temp[1], _=>formatWebpParams(_))
        }
        el.style.background = value
      }
      if (window.SUPPORT_WEBP) {
        _bind()
      } else {
        webpFormat().then(() => {_bind()})
      }
    },
    update: function(el, binding, vnode) {
      if (binding.value != binding.oldValue) {
        const regx = /url\((.*?)\)/g
        let value = binding.value
        let temp
        while(temp = regx.exec(binding.value)) {
          value = value.replace(temp[1], _=>formatWebpParams(_))
        }
        el.style.background = value
      }
    }
  }
}]

export default {
  install (Vue) {
    directives.forEach(({key, options}) => {
      Vue.directive(key, options)
    })
  } 
}